import React from 'react';
import PropTypes from 'prop-types';
import Slider from 'react-slick';
import { makeStyles } from '@material-ui/core/styles';
import { ArrowBackIos, ArrowForwardIos } from '@material-ui/icons';
import classnames from 'classnames';
import Img from 'react-image';
import ImageSlideDescription from '../ImageSlideDescription';
import { colors } from '../../constants/styleConstants';

import NextLink from '../NextLink';

const useStyles = makeStyles(theme => ({
  contentWrapper: {
    display: 'flex',
    alignItems: 'center',
  },

  modalImg: {
    maxWidth: '100%',
    maxHeight: '60vh',
    objectFit: 'cover',
    objectPosition: 'top',
    lineHeight: 0,
    [theme.breakpoints.down('sm')]: {
      width: '100%',
      maxWidth: '100%',
      maxHeight: '60vh',
    },
  },
  modalImgContainer: {
    display: 'flex',
    justifyContent: 'center',
    minHeight: '60vh',
    alignItems: 'center',
    lineHeight: 0,
    width: '50vw',
    height: 'auto',
    maxHeight: 'auto',
    maxWidth: '50vw',
    background: colors.background.grayLight,
    flexGrow: 1,
    '&:focus': {
      outline: 'none',
    },
    [theme.breakpoints.down('sm')]: {
      width: '100%',
      maxWidth: '100%',
      maxHeight: 'auto',
    },
  },
  customArrow: {
    width: '37px !important',
    height: '37px !important',
    borderRadius: '50%',
    zIndex: 10,
    position: 'absolute',
    backgroundColor: '#ebebeb',
    boxShadow: '0 12px 16px 0 rgba(69, 91, 99, 0.1)',
    display: 'flex !important',
    alignItems: 'center',
    justifyContent: 'center',
    '&:before': {
      content: 'none !important',
    },
    top: '50%',
    marginTop: '-18px',
    cursor: 'pointer',
  },
  customLeft: {
    left: '10px !important',
    right: 'auto !important',
  },
  customRight: {
    right: '10px !important',
    left: 'auto !important',
  },
}));

const ImageGallery = ({ images, chosenImage }) => {
  const classes = useStyles();
  const arrayAfterChosenImage = images.slice(chosenImage, images.length);
  const arrayBeforeChosenImage = images.slice(0, chosenImage);

  const updatedImages = arrayAfterChosenImage.concat(arrayBeforeChosenImage);

  const PrevArrow = ({ onClick }) => (
    <div className={classnames(classes.customArrow, classes.customLeft)} onClick={onClick}>
      <ArrowBackIos style={{ fontSize: 12, color: colors.blueLight, marginLeft: 3 }} />
    </div>
  );

  const NextArrow = ({ onClick }) => (
    <div className={classnames(classes.customArrow, classes.customRight)} onClick={onClick}>
      <ArrowForwardIos style={{ fontSize: 12, color: colors.blueLight }} />
    </div>
  );
  const NoArrow = () => <div />;

  const settings = {
    dots: false,
    arrows: true,
    infinite: true,
    slidesToShow: 1,
    slidesToScroll: 1,
    nextArrow: images.length > 1 ? <NextArrow /> : <NoArrow />,
    prevArrow: images.length > 1 ? <PrevArrow /> : <NoArrow />,
    adaptiveHeight: true,
    swipe: images.length > 1,
  };

  return (
    <Slider {...settings}>
      {updatedImages.map((image, index) => (
        <div key={index}>
          <div className={classes.modalImgContainer}>
            <Img className={classes.modalImg} src={image.srcView} alt={image.alt} />
          </div>
          {image.imageSlideDescription && <ImageSlideDescription key={index} image={image} />}
        </div>
      ))}
    </Slider>
  );
};

ImageGallery.propTypes = {
  images: PropTypes.arrayOf(
    PropTypes.shape({
      srcPreview: PropTypes.string,
      srcView: PropTypes.string,
      src: PropTypes.string,
      alt: PropTypes.string,
      tags: PropTypes.arrayOf(
        PropTypes.shape({
          linkText: PropTypes.string,
          linkProps: PropTypes.oneOfType([PropTypes.shape({ ...NextLink.propTypes }), PropTypes.func]),
        }),
      ),
      descriptionTitle: PropTypes.string,
      musicalWork: PropTypes.string,
      musicalWorkLinkProps: PropTypes.shape(NextLink.propTypes),
      company: PropTypes.string,
      companyLinkProps: PropTypes.shape(NextLink.propTypes),
    }),
  ).isRequired,
  chosenImage: PropTypes.number,
};

export default ImageGallery;
